module.exports = __webpack_public_path__ + "static/00013.ad837770.jpg";